import React, { useState } from 'react';

function FAQs() {
  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  const faqs = [
    {
      question: "What is the solar subsidy available for residential rooftop installations in India?",
      answer: "The Government of India provides attractive subsidies for residential rooftop solar installations: Systems up to 1 kW receive ₹30,000, systems up to 2 kW get ₹60,000, and systems between 3-10 kW receive ₹78,000. Additionally, Uttar Pradesh offers an extra state subsidy of ₹15,000 per kW (maximum ₹30,000), bringing the total maximum subsidy to ₹1,08,000 for eligible households."
    },
    {
      question: "How much electricity can I expect to generate from my solar system?",
      answer: "Solar generation depends on location, weather, and system capacity. In India, you can expect approximately 4-5 kWh per kW of installed capacity per day on average. A 3 kW system typically generates 12-15 kWh daily, which is sufficient for most Indian households. Generation is higher during sunny months (March-June) and lower during monsoon season. We provide detailed generation estimates based on your specific location and roof orientation during our site assessment."
    },
    {
      question: "Is there any subsidy available for housing societies?",
      answer: "Yes, housing societies can benefit from solar subsidies. They receive ₹18,000 per kW up to a maximum of ₹90 lakhs. This makes solar installations highly cost-effective for apartment complexes and housing societies looking to reduce their electricity bills and carbon footprint."
    },
    {
      question: "Do commercial and industrial solar installations qualify for subsidies?",
      answer: "No, the government subsidy scheme currently does not cover commercial and utility-scale solar installations. However, commercial installations still benefit from significant cost savings through reduced electricity bills, tax incentives, depreciation benefits, and various state-level incentives that make solar power a highly profitable investment for businesses."
    },
    {
      question: "How long does it take to install a rooftop solar system?",
      answer: "Typically, a residential rooftop solar installation takes 2-5 days depending on the system size and complexity. The process includes site assessment, obtaining necessary permissions, panel installation, inverter setup, electrical connections, and testing. For larger commercial installations, the timeline may extend to 1-2 weeks."
    }
  ];

  return (
    <div className="container faqs-section">
      <h2 className="main-title text-center">FREQUENTLY ASKED QUESTIONS</h2>
      <div className="faqs-container">
        {faqs.map((faq, index) => (
          <div key={index} className={`faq-item ${openFAQ === index ? 'open' : ''}`}>
            <div 
              className="faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span className="faq-text">{faq.question}</span>
              <span className="faq-plus-icon" aria-hidden="true"></span>
            </div>
            <div className={`faq-answer ${openFAQ === index ? 'open' : ''}`}>
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQs;
